import { render, staticRenderFns } from "./DomainMonitorList.vue?vue&type=template&id=05b5781a&scoped=true&"
import script from "./DomainMonitorList.vue?vue&type=script&lang=js&"
export * from "./DomainMonitorList.vue?vue&type=script&lang=js&"
import style0 from "./DomainMonitorList.vue?vue&type=style&index=0&id=05b5781a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b5781a",
  null
  
)

export default component.exports